import React from 'react';
import { useData } from '../context/DataContext';

const Clients = () => {
  const { clients } = useData();

  return (
    <div>
      <h2>👤 Clients</h2>
      <div className="cout-summary">
        <div className="cout-summary-item">
          <span>Total clients</span>
          <strong>{clients.length}</strong>
        </div>
      </div>
      <div className="table-scroll">
        <table className="data-table" role="table">
        <thead>
          <tr>
            <th>Client</th>
            <th>Adresse</th>
            <th>Nb devis</th>
            <th>Nb factures</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((c, i) => (
            <tr key={i}>
              <td>{c.nom}</td>
              <td>{c.adresse}</td>
              <td>{c.nbDevis}</td>
              <td>{c.nbFactures}</td>
            </tr>
          ))}
          {clients.length === 0 && (
            <tr>
              <td colSpan="4" style={{ textAlign: 'center', color: 'var(--color-text-secondary)', padding: '2rem' }}>
                Aucun client. Importez des données depuis l'onglet "Tableau de bord".
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Clients;